import { Document } from '@contentful/rich-text-types';
import { ContentfulModel } from './ContentfulModel';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { Link } from './Link';
import { Tip } from './Tip';
import { Asset } from './Asset';

export class Article extends ContentfulModel {
    private title: string;
    private subtitle: string|null;
    private keyword: string|null;
    private slug: string;
    private imageId: string;
    private description: Document;
    private tipIds: string[];
    private linkIds: string[];

    parseContentfulData(object: any): void {
        this.title = object.title;
        this.subtitle = object.subtitle ?? null;
        this.keyword = object.keyword ?? null;
        this.slug = object.slug;
        this.imageId = object.image.sys.id;
        this.description = object.description;
        this.tipIds = object.tips?.map(x => x.sys.id) ?? [];
        this.linkIds = object.links?.map(x => x.sys.id) ?? [];
    }

    getTitle(): string {
        return this.title;
    }

    getSubtitle(): string|null {
        return this.subtitle;
    }

    getKeyword(): string|null {
        return this.keyword;
    }

    getSlug(): string {
        return this.slug;
    }

    getImage(): Asset {
        return this.getById(this.imageId) as Asset;
    }

    getDescription(): string {
        return documentToHtmlString(this.description);
    }

    getTips(): Tip[] {
        return this.tipIds.map(x => this.getById(x) as Tip);
    }

    getLinks(): Link[] {
        return this.linkIds.map(x => this.getById(x) as Link);
    }

    getType(): string {
        return 'article';
    }
};
